"use strict";
const React = require('react');
const style = {
    fontSize: '14px',
    color: 'rgba(0, 0, 0, 0.5)',
};
const Label = (props) => React.createElement("label", {style: Object.assign({}, style, props.style)}, props.text);
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Label;



/** WEBPACK FOOTER **
 ** ./src/components/Label.tsx
 **/